import {
  whatsappSupportNumber,
  sctecWhatsappSupportNumber,
  discordLocation,
  sctecDiscordLocation,
  emailSupport,
  sctecEmailSupport
} from '../../../config/env.json';

export function getSupportWhatsappNumber(isSCTEC: boolean): string {
  return String(
    isSCTEC && sctecWhatsappSupportNumber
      ? sctecWhatsappSupportNumber
      : whatsappSupportNumber
  );
}

export function getSupportDiscordUrl(isSCTEC: boolean): string {
  return String(
    isSCTEC && sctecDiscordLocation ? sctecDiscordLocation : discordLocation
  );
}

export function getSupportEmail(isSCTEC: boolean): string {
  return String(
    isSCTEC && sctecEmailSupport ? sctecEmailSupport : emailSupport
  );
}

const SCTEC_DEFAULT_SUPPORT_EMAIL = 'sctec@scti.sc.gov.br';

export function getSctecSupportEmail(): string {
  return String(sctecEmailSupport || SCTEC_DEFAULT_SUPPORT_EMAIL);
}

export function hasSctecDiscordConfigured(): boolean {
  return !!sctecDiscordLocation;
}

export function getSupportInfoText(
  isSCTEC: boolean,
  context: 'error' | 'question'
): string {
  if (context === 'error') {
    return isSCTEC
      ? 'Encontrei um erro na plataforma do curso'
      : 'Encontrei um erro na plataforma do DEVstart';
  }
  return isSCTEC ? 'Olá' : 'Estou com uma dúvida em um exercício do DEVstart';
}

export function buildWhatsappUrl(number: string, infoText: string): string {
  return `https://api.whatsapp.com/send/?phone=${number}&text=${infoText}&type=phone_number&app_absent=0`;
}
